export const enum RootPaths {
  ROOT = '/',
  TASKS = '/tasks',
  CLAIMS = '/claims',
  USERS = '/users',
  CLAIM_SET = '/claim-set/:claimSetNumber',
  PRODUCER = '/producer/:producerId',
  SIGN_IN = '/sign-in',
  OTP = '/otp',
  FORGOT_PASSWORD = '/forgot-password',
  FORGOT_USERNAME = '/forgot-username',
  FORGOT_PASSWORD_EMAIL = '/forgot-password-email',
  FORGOT_USERNAME_EMAIL = '/forgot-username-email',
  UPDATE_PASSWORD = '/update-password',
  PARTY_DETAILS = '/party-details/:partyId',
}

export const enum EditUserPaths {
  USERS = RootPaths.ROOT + 'users',
}

export const enum ProfileDetailsPaths {
  PROFILE_DETAILS = RootPaths.ROOT + 'profile-details',
}

export const DEFAULT_PATH = RootPaths.TASKS;
